import { Examples } from '@/types';

export const ExampleMStoreSpinnerButtonRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleMStoreSpinnerButton,
        components: {
          default: () => import(/* webpackChunkName: "ExampleMStoreAccordion" */
            '@/views/examples/ExampleMStoreSpinnerButton.vue')
        }
      }
    ]
    : [];
